import * as React from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

export default function TopProductCard({ topCountMachineName, topProductName, topProductCount }) {
  const { t } = useTranslation();

  return (
    <Paper
      elevation={1}
      sx={(theme) => ({
        height: '100%',
        px: 2,
        py: 2,
        backgroundColor: theme.palette.mode === "dark" ? "#1a237e" : "#e3f2fd",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
      })}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
        }}
      >
        <ShoppingCartRoundedIcon
          sx={(theme) => ({
            fontSize: 32,
            color: theme.palette.mode === 'dark' ? '#64b5f6' : '#1976d2',
            opacity: 0.3,
          })}
        />
      </Box>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontWeight: 600, display: 'block', mb: 1, fontSize: '0.9rem', textAlign: 'center' }}
      >
        {t('vendingSales.topSellingMachineByCount', 'En Çok Satış Yapan Otomat (Adet)')}
      </Typography>

      <Box sx={{ my: 1, textAlign: 'center' }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: '700',
            color: 'text.primary',
            mb: 1,
          }}
        >
          {topCountMachineName || t('vendingSales.noData', 'Veri Yok')}
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontWeight: '700',
            color: '#1565c0',
          }}
        >
          {topProductName && topProductCount
            ? t('vendingSales.selectionWithCount', 'Seçim {{productName}} / {{count}} Adet', {
                productName: topProductName,
                count: topProductCount.toLocaleString()
              })
            : '-'
          }
        </Typography>
      </Box>

      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          mt: 0.5,
          fontSize: '0.75rem',
        }}
      >
        {t('vendingSales.topSellingProduct', 'En Çok Satılan Ürün')}
      </Typography>
    </Paper>
  );
}

TopProductCard.propTypes = {
  topCountMachineName: PropTypes.string,
  topProductName: PropTypes.string,
  topProductCount: PropTypes.number,
};
